import React from "react";
import { Container } from "@/components/ui-kit";

export function LegalLayout({ title, subtitle, updated, children }) {
  return (
    <div data-testid="legal-page">
      <section className="bg-[#0F172A]">
        <Container className="py-14 md:py-16">
          <h1 className="text-3xl sm:text-4xl font-bold font-display text-white text-balance">{title}</h1>
          {subtitle && <p className="mt-3 text-slate-300 text-lg">{subtitle}</p>}
          {updated && <p className="mt-4 text-sm text-slate-400">Last updated: {updated}</p>}
        </Container>
      </section>
      <section className="py-16 md:py-20 bg-white">
        <Container className="max-w-3xl">
          <div className="legal-content space-y-2">{children}</div>
        </Container>
      </section>
    </div>
  );
}

export function H({ children }) {
  return <h2 className="text-xl sm:text-2xl font-bold font-display text-[#0F172A] mt-10 mb-3">{children}</h2>;
}

export function H3({ children }) {
  return <h3 className="text-lg font-semibold font-display text-[#0F172A] mt-6 mb-2">{children}</h3>;
}

export function P({ children, ...props }) {
  return <p className="text-[#475569] leading-relaxed mb-4" {...props}>{children}</p>;
}

export function Lead({ children }) {
  return <p className="text-[#1E293B] leading-relaxed mb-4 text-lg">{children}</p>;
}

export function UL({ items }) {
  return (
    <ul className="space-y-2 mb-4 ml-1">
      {items.map((it, i) => (
        <li key={i} className="flex items-start gap-3 text-[#475569] leading-relaxed">
          <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#10B981] shrink-0" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  );
}

export function Callout({ children }) {
  return (
    <div className="rounded-xl border-l-4 border-[#10B981] bg-[#F8FAFC] p-5 my-6">
      <p className="text-[#1E293B] leading-relaxed">{children}</p>
    </div>
  );
}
